import { centeredMainGridClasses } from '@/styles/grid';
import * as React from 'react';
import { StaggeredListFieldsFragment } from 'types/generated';
import ListItem from './ListItem';

type Props = {
  data: StaggeredListFieldsFragment;
};
const StaggeredList = ({ data }: Props) => {
  const collection = data.listItemsCollection;

  return (
    <div className={`${centeredMainGridClasses} gid-flow-row md:grid-flow-column gap-16`}>
      {collection?.items &&
        collection.items.map(function (object, i) {
          {
            return (
              object && (
                <ListItem
                  title={object.title ? object?.title : ''}
                  discription={object?.description}
                  icon={object.icon ? object?.icon?.url : ''}
                  leftAligned={i % 2 === 1}
                />
              )
            );
          }
        })}
    </div>
  );
};
export default StaggeredList;
